module.exports = __webpack_public_path__ + "img/Asistencia_funeraria_conductor.b295db79.svg";